module.exports = __webpack_public_path__ + "static/media/gastreghini-logo.7bbfefa0.png";